import { writable } from 'svelte/store';

const createUserObjStore = () => {
  const { subscribe, set, update } = writable({});

  return {
    subscribe,
    set,
    update,
    setAttribute: (key, value) => update(state => ({ ...state, [key]: value })),
    removeAttribute: (key) => update(state => {
      const { [key]: removed, ...rest } = state;
      console.log('removed', removed);
      return rest;
    }),
    reset: () => set({}),
    isAuthenticated: () => {
      let value;
      const unsubscribe = subscribe(state => {
        if (state.isAuthenticated !== undefined) {
          value = state.isAuthenticated;
        } else {
          value = false;
        }
      })();
      unsubscribe();
      return value;
    }
  };
};

export const userObj = createUserObjStore();